export default "__VITE_ASSET__Ck_2MXel__"